import React, {Component, PropTypes} from 'react';
import { Pie } from 'react-chartjs';
import DataPackageTopUpDialog from './data-package-topup-dialog';
import DataPackageDialog from './data-package-dialog';
import { formatDate } from '../../utils/date';
import { dateDiffFromTodayinDays } from '../../utils/date';
import { format } from '../../utils/string';
import { lang } from '../../strings';

export default class DataPackage extends Component {

   constructor(props) {
      super(props);
      this.state = this.makeInitialState(props);
   }

   makeInitialState(props) {
      return {
         orderTopUp: false,
         changeDataPackage: false,
         hasOrderedTopUp: false
      };
   }

   render() {
      let {dataCapStatus, dataPackages, dataPackageTasks, dataPackageName, netType, hasDataPackage} = this.props;
      let { orderTopUp, changeDataPackage, hasOrderedTopUp } = this.state;

      let hasAvailableDataPackages = dataPackages.availableDataPackages && dataPackages.availableDataPackages.length > 0;
      let canChangeDataPackage = dataPackageTasks && dataPackageTasks.length === 0 && netType !== 'MobileBroadband' && hasAvailableDataPackages;
      let canAddDataTopUp = dataCapStatus && dataPackages.availableTopUps && dataPackages.availableTopUps.length > 0;
      let data = [];

       if(dataCapStatus) {
          data = [
              {
                  value: dataCapStatus.usedDataVolume,
                  color: "#FF674D",
                  highlight: "#FF674D",
                  label: lang.dataPackage.used
              },
              {
                  value: dataCapStatus.remainingDataVolume,
                  color: "#181C54",
                  highlight: "#181C54",
                  label: lang.dataPackage.remaining
              }
          ];
      }

      let options = {
         animation: false
      };

      return (
         <div className="mp-tile">
            <h2 className="h5 color-dark-blue">{lang.dataPackage.title}</h2>
            {hasOrderedTopUp ? <p className="mp-info">{lang.dataPackage.hasOrdered}</p> : null}
            {dataPackageTasks && dataPackageTasks.length > 0
               ? dataPackageTasks.map(task => <p key={task.id} className="mp-task-info">{format(lang.subscription.tasks.dataPackage, formatDate(task.activationDate, 'LL'), task.description)}</p>)
               : null
            }

            <p>{lang.dataPackage.current}: {dataPackageName}</p>

            {hasDataPackage ? this.renderDataCap(dataCapStatus, data, options) : null}

            <div className="grid-y">
               {canAddDataTopUp ? <a href="#" className="link" onClick={this.showTopUp}>{lang.dataPackage.topUp.title}</a> : null}
            </div>
            {orderTopUp ? <DataPackageTopUpDialog onSubmit={this.orderTopUp} onClose={this.hideTopUp} topUps={dataPackages.availableTopUps}/> : null}
            {changeDataPackage ? <DataPackageDialog onSubmit={this.orderDataPackageChange}
                                                    onClose={this.hideChangeDataPackage}
                                                    dataPackages={dataPackages.availableDataPackages}
                                                    currentDataPackage={dataPackageName}/> : null}
         </div>
      );
   }

   renderDataCap(dataCapStatus, data, options){
       return (
            <div>{dataCapStatus ?
                <div>
                    <div className="mp-block">
                        <div className="mp-block-half"><Pie data={data} options={options} height="120" width="120" /></div>
                        <div className="mp-block-half">{this.renderLabels(data)}</div>
                    </div>
                       <p className="mp-small">{format(lang.dataPackage.resetDate, dateDiffFromTodayinDays(dataCapStatus.resetDate), formatDate(dataCapStatus.resetDate, 'LL'))}</p>
                </div> :
                <p className="mp-info">{lang.dataPackage.notAvailable}</p>}
            </div>
       );
   }

   renderLabels(slices) {
      return (
         <table className="mp-table">
            <tbody>
            <tr>
               <th colSpan="2">{lang.dataPackage.usage}</th>
            </tr>
            {
               slices.map(function(slice, index) {
                  let {color, label, value} = slice;
                  return (
                     <tr key={index}>
                        <td>
                           <div style={{height: 15, width: 15, backgroundColor: color}}></div>
                        </td>
                        <td>{label}: {value} GB</td>
                     </tr>
                  );
               })
            }
            </tbody>
         </table>
      );
   }

   orderTopUp = data => {
      this.props.orderTopUp(data);
      this.setState({orderTopUp: false, hasOrderedTopUp: true});
   };

   showTopUp = ev => {
      ev.preventDefault();
      this.setState({orderTopUp: true});
   };

   hideTopUp = () => {
      this.setState({orderTopUp: false});
   };

   orderDataPackageChange = data => {
      this.props.changeDataPackage(data);
      this.setState({changeDataPackage: false});
   };

   showChangeDataPackage = ev => {
      ev.preventDefault();
      this.setState({changeDataPackage: true});
   };

   hideChangeDataPackage = () => {
      this.setState({changeDataPackage: false});
   };

}

DataPackage.propTypes = {
   orderTopUp: PropTypes.func.isRequired,
   changeDataPackage: PropTypes.func.isRequired,
   dataPackages: PropTypes.object.isRequired,
   netType: PropTypes.string.isRequired,
   hasDataPackage: PropTypes.bool.isRequired
};